<template>
  <div style="">
    <el-row>
      <span >
        <el-button type="text" @click="add">Add New <i class="fas fa-plus-square"/></el-button>
        <el-input v-debounce="getAll" :debounce-events="'keydown'" v-model="term" size="small" type="text" placeholder="search" style="width: 40em" ><i slot="suffix" class="el-input__icon el-icon-search"/></el-input>
      </span>
    </el-row>
    <el-row>
      <el-col>
        <el-table
          ref="multipleTable"
          :data="agency"
          border
          style="width: 100%">
          <el-table-column prop="name" label="Agency Name" />
          <el-table-column prop="address" label="Address" />
          <el-table-column label="Action">
            <template slot-scope="scope">
              <el-button type="success" size="mini" @click ="edit(scope.row)" ><i class="fas fa-file-invoice"/>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center;">
          <el-pagination :page-size="meta.per_page" :pager-count="11" :total="meta.total" :current-page.sync="meta.page" layout="total, prev, pager, next" @current-change="getAll"/>
        </div>
      </el-col>
    </el-row>
    <el-dialog v-if="selected" :visible.sync="editable" :title="title" width="50%" center >
      <el-form ref="selected" :model="selected" label-position="top">
        <el-form-item label="Agency Name" prop="name">
          <el-input
            v-model="selected.name"
            placeholder="Please input"
            clearable />
        </el-form-item>
        <el-form-item label="Address" prop="address">
          <el-input
            v-model="selected.address"
            placeholder="Please input"
            clearable />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editable = false">Cancel</el-button>
        <el-button type="primary" @click="save()">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Agency } from '@/api/payroll/agency'
import { Notification } from 'element-ui'
export default {
  name: 'Agency',
  data() {
    return {
      meta: {
        page: 1
      },
      agency: [],
      term: '',
      editable: false,
      selected: null
    }
  },
  created() {
    this.getAll()
  },

  methods: {
    getAll() {
      this.editable = false
      this.selected = null
      Agency({ term: this.term, page: this.meta.page }).then(res => {
        this.agency = res.data.agencies
        this.meta = res.data.meta
      }).catch(error => {
        console.log(error)
      })
    },
    edit(index) {
      this.selected = Object.assign({}, index)
      this.editable = true
      this.title = 'Edit Agency'
    },
    add() {
      this.selected = {}
      this.title = 'New Agency'
      this.editable = true
    },

    save() {
      var action = this.selected.id ? 'patch' : 'post'
      Agency(this.selected, action).then(res => {
        Notification.success({
          title: 'Success',
          message: 'Agency has been saved successfully',
          duration: 4 * 1000
        })
        this.getAll()
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

